var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import RecipeCard from './RecipeCard';
import arrow from '../../images/arrow.svg';
import variables from '../utilities/_variables';
const { base_url } = variables;
export default class BtnMore {
    constructor(request) {
        this.request = request;
    }
    render() {
        return __awaiter(this, void 0, void 0, function* () {
            // create the element
            const div = document.createElement('div');
            div.id = `btn_more_container`;
            div.innerHTML = `
            <button id="btn_more">
                Random<img src="${arrow}" />
            </button>
        `;
            // mount to DOM
            const main = document.querySelector('#list');
            main.appendChild(div);
            // attach onlick event listener
            const button = document.querySelector('#btn_more');
            button.onclick = () => __awaiter(this, void 0, void 0, function* () {
                const parent = document.querySelector('#list_recipecards');
                for (let count = 1; count <= 9; count++) {
                    const raw = yield fetch(`${base_url}${this.request}`);
                    const { meals } = yield raw.json();
                    const meal = meals[0];
                    const { idMeal, strMeal, strCategory, strMealThumb, strSource, strArea } = meal;
                    const li = yield new RecipeCard(idMeal, strMeal, strMealThumb, strArea, strCategory, strSource).render();
                    parent.appendChild(li);
                    const image = document.getElementById(`image_${idMeal}`);
                    image.style.backgroundImage = `url(${strMealThumb})`;
                }
            });
        });
    }
}
